// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ypiVQYaGUrIaV1 {
  width: 13px;
}
.ypiVQYaGUrIaV1 svg {
  width: 12px;
  height: 12px;
}
`, ""]);
// Exports
export var aiIcon = `ypiVQYaGUrIaV1`;
export default ___CSS_LOADER_EXPORT___;
